export default __webpack_public_path__ + "static/media/card-theme1.31b5c522.svg";